// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1QjVT","lazy":"style_lazy__3O4ky","cropper":"style_cropper__2oL6d","vertical":"style_vertical__15WaC"};